<script setup lang="ts">
/**
 * What stands in for the tmux view while its code is still on the way — it is
 * a chunk of its own, and on a slow connection the longest wait of any view.
 * Shaped like the view: the repo list, and beside it the git panel's rows,
 * which is what the view opens on (a phone: the rows alone).
 */
</script>

<template>
  <section class="tmux-view tmux-loading" role="status" aria-label="Loading the tmux view">
    <aside class="tmux-list" aria-hidden="true">
      <div class="skel-list">
        <div v-for="i in 5" :key="i" class="skel-row"><i class="skel" :style="{ width: `${40 + ((i * 23) % 45)}%` }"></i><i class="skel skel-count"></i></div>
      </div>
    </aside>
    <div class="tmux-main" aria-hidden="true">
      <div class="tmux-term-skel">
        <span class="skel-lines"><i></i><i></i><i></i><i></i><i></i><i></i></span>
      </div>
    </div>
    <div class="tmux-loading-git skel-list" aria-hidden="true">
      <div v-for="i in 8" :key="i" class="skel-row git-skel-row"><i class="skel skel-dot"></i><i class="skel" :style="{ width: `${35 + ((i * 29) % 50)}%` }"></i><i class="skel skel-count"></i></div>
    </div>
  </section>
</template>
